import React from "react";

const GrowWithUs = () => {
  return (
    <section id="talent" className="section-padding">
      <div className="container">
        <div className="grow-grid">
          <div className="grow-content">
            <h2 className="section-heading">Grow with us</h2>
            <p className="section-text">
              We connect you with roles that fit your skills, ambitions, and values. We'll also help you navigate compensation with clarity. If your ask is below market, we'll tell you — and guide you to a range that reflects your worth. If it's above current signals, we'll show the data and help you position your value. The goal is simple: informed choices and outcomes you feel good about.
            </p>
            <div className="grow-benefits">
              <div className="benefit-point">
                <span className="benefit-check">✓</span>
                <span><strong>Compensation transparency:</strong> If your rate expectations are below market, we'll tell you exactly what you should be asking for</span>
              </div>
              <div className="benefit-point">
                <span className="benefit-check">✓</span>
                <span><strong>Market trends & demand insights:</strong> Stay informed about current market trends, in-demand skills, and what specific technologies organizations are actively seeking</span>
              </div>
              <div className="benefit-point">  
                <span className="benefit-check">✓</span>
                <span><strong>Career strategy:</strong> Each placement is designed to build toward your next career milestone</span>
              </div>
              <div className="benefit-point">
                <span className="benefit-check">✓</span>
                <span><strong>Priority access:</strong> Government and financial sector roles through our established client partnerships and pre-qualified talent networks</span>
              </div>
            </div>
          </div>
          <div className="grow-image">
            <img 
              src="https://images.unsplash.com/photo-1579403124614-197f69d8187b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMG1lZXRpbmd8ZW58MHx8fHwxNzU4MTg4MDE0fDA&ixlib=rb-4.1.0&q=85"
              alt="Software development workspace with multiple monitors"
              className="section-image"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GrowWithUs;